<!--
 * @Description:
 * @Author: miao.zhang
 * @Date: 2020-11-19 14:15:38
 -->
<template>
  <el-dialog
    class="add-user"
    title="新增用户"
    :visible.sync="dialogFormVisible"
    :close-on-press-escape="false"
    :show-close="false"
    :close-on-click-modal="false"
  >
    <ts-form
      :form-list="formList"
      :name="addTenantUser"
      @close-dialog="handleCloseDialog"
      @activationCodes="handleActivationCodes"
    />
  </el-dialog>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { addTenantUser } from '@/api/manage/userManage'
import TsForm from '@/components/TsForm/index.vue'
@Component({
  name: 'addNewDialog',
  components: {
    TsForm,
  },
})
export default class extends Vue {
  @Prop({ default: false }) value
  @Prop({ default: Array }) allActivationList
  @Prop({ default: Array }) allRolesList
  addTenantUser = addTenantUser
  formList = [
    {
      label: '用户姓名',
      prop: 'name',
      type: 'input',
      rules: [{ required: true, message: '用户姓名不能为空' }],
      placeholder: '请输入有效姓名', // 如果需要就加上 默认为''
    },
    {
      label: '用户账号/手机号',
      prop: 'mobile',
      type: 'input',
      // isNumber: true, // input类型的如果为数字输入框需要加上
      rules: [
        { required: true, message: '用户账号/手机号不能为空' },
        {
          pattern: /^(((13[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9])|(14[0-9]))+\d{8})$/,
          message: '用户账号/手机号格式错误',
          trigger: 'blur',
        },
      ], // 若为必填字段需要加上
    },
    {
      label: '用户职位',
      prop: 'positionName',
      type: 'input',
      rules: [{ required: true, message: '用户职位不能为空' }],
      placeholder: '请输入有效职位', // 如果需要就加上 默认为''
    },
    {
      label: '用户邮箱',
      prop: 'email',
      type: 'input',
      rules: [
        { required: true, message: '用户邮箱不能为空' },
        {
          pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
          message: '邮箱格式错误',
          trigger: 'blur',
        },
      ],
      placeholder: '请输入有效邮箱', // 如果需要就加上 默认为''
    },
    {
      label: '选择许可证',
      prop: 'activationCodeIds',
      type: 'select',
      multiple: true, // 是否多选 默认false
      rules: [
        {
          required: true,
          type: 'array',
          message: '绑定许可证不能为空',
          trigger: 'blur',
        },
      ],
      options: [], // select类型的需要options,
    },
    {
      label: '绑定许可证',
      prop: 'activationCodeId',
      type: 'select',
      rules: [
        { required: true, message: '绑定许可证不能为空', trigger: 'blur' },
      ],
      options: [], // select类型的需要options,
    },
    {
      label: '用户角色',
      prop: 'userRoles',
      type: 'select',
      multiple: true, // 是否多选 默认false
      options: [], // select类型的需要options,
      // rules: [{ required: true, type: 'array', message: '用户角色不能为空', trigger: 'blur' }]
    },
  ]

  dialogFormVisible = false
  @Watch('value')
  onValueChanged(newVal) {
    this.dialogFormVisible = newVal
    if (newVal) {
      this.formList[4].options = this.allActivationList.length
        ? this.allActivationList.map((item) => {
            item = Object.assign({}, item, {
              anotherName: item.name + '  剩余' + item.availableCounts + '个',
              disabled: !item.availableCounts,
            })
            if (!item.availableCounts) {
              item = Object.assign({}, item, {
                disabled: true,
              })
            }
            return item
          })
        : []
      this.formList[6].options = this.allRolesList
    }
  }

  handleActivationCodes(list) {
    this.formList[5].options = list
  }

  handleCloseDialog(type) {
    this.dialogFormVisible = false
    this.formList[5].options = []
    if (type !== 'noValue') {
      this.$message({ type: 'success', message: '添加成功' })
    }
    this.$emit('input', false)
    this.$emit('on-close', type)
  }
}
</script>

<style lang="scss">
.add-user {
  .el-dialog__body {
    padding: 10px 20px 20px 20px;
  }
}
</style>
